var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner tracking-detail-form",
      staticStyle: { display: "flex", "flex-direction": "column" }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { height: "100%", "margin-left": "-32px !important" }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "row" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card", staticStyle: { width: "450px" } },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [_vm._v(_vm._s(_vm.title))])
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "trackingDetailForm",
                      staticStyle: { width: "100%", "margin-bottom": "20px" },
                      attrs: {
                        disabled: _vm.readOnly,
                        "label-position": "left",
                        "label-width": "90px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Pricing.FeeIndex") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d]/g,'')",
                                  type: "number"
                                },
                                model: {
                                  value: _vm.trackingDetailForm.level,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.trackingDetailForm,
                                      "level",
                                      $$v
                                    )
                                  },
                                  expression: "trackingDetailForm.level"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  model: {
                                    value: _vm.trackingDetailForm.defaultNode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.trackingDetailForm,
                                        "defaultNode",
                                        $$v
                                      )
                                    },
                                    expression: "trackingDetailForm.defaultNode"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("Sop.InitialState")))]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Code") } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.isPlatformCode && _vm.isEdit
                            },
                            on: {
                              blur: function() {
                                return (_vm.trackingDetailForm.code = _vm.trackingDetailForm.code.trim())
                              }
                            },
                            model: {
                              value: _vm.trackingDetailForm.code,
                              callback: function($$v) {
                                _vm.$set(_vm.trackingDetailForm, "code", $$v)
                              },
                              expression: "trackingDetailForm.code"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_ChineseName") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.isPlatformCode && _vm.isEdit
                            },
                            on: {
                              blur: function() {
                                return (_vm.trackingDetailForm.codeCname = _vm.trackingDetailForm.codeCname.trim())
                              }
                            },
                            model: {
                              value: _vm.trackingDetailForm.codeCname,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.trackingDetailForm,
                                  "codeCname",
                                  $$v
                                )
                              },
                              expression: "trackingDetailForm.codeCname"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_EnglishName") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.isPlatformCode && _vm.isEdit
                            },
                            on: {
                              blur: function() {
                                return (_vm.trackingDetailForm.codeEname = _vm.trackingDetailForm.codeEname.trim())
                              }
                            },
                            model: {
                              value: _vm.trackingDetailForm.codeEname,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.trackingDetailForm,
                                  "codeEname",
                                  $$v
                                )
                              },
                              expression: "trackingDetailForm.codeEname"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Sop.StatusType") } },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.trackingDetailForm.stateType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm,
                                    "stateType",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.stateType"
                              }
                            },
                            _vm._l(_vm.stateTypes, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.value
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.typeChange },
                              model: {
                                value: _vm.trackingDetailForm.type,
                                callback: function($$v) {
                                  _vm.$set(_vm.trackingDetailForm, "type", $$v)
                                },
                                expression: "trackingDetailForm.type"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Sop.AutomaticTriggering")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: !_vm.trackingDetailForm.type },
                              on: { change: _vm.triggerWayChange },
                              model: {
                                value: _vm.trackingDetailForm.triggerWay,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm,
                                    "triggerWay",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.triggerWay"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: _vm.TRIGGER_WAY_ENUM.FIELD }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SystemMaintenance.TriggerBasedOnFieldValue"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    label:
                                      _vm.TRIGGER_WAY_ENUM
                                        .SPECIFIC_BUSINESS_RULE
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SystemMaintenance.TriggeredToSpecificBusinessRules"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_TriggerType") }
                        },
                        [
                          _vm.trackingDetailForm.triggerWay ===
                          _vm.TRIGGER_WAY_ENUM.FIELD
                            ? [
                                _vm.readOnly || !_vm.trackingDetailForm.type
                                  ? _c("el-input", {
                                      attrs: {
                                        value: _vm.fieldEventName,
                                        disabled: ""
                                      }
                                    })
                                  : _c("trigger-dialog", {
                                      attrs: {
                                        "row-data": _vm.triggerTypeList,
                                        title: _vm.$t(
                                          "CargoMsg.Cargo_TriggerTypeSelection"
                                        ),
                                        "column-defs":
                                          _vm.triggerTypeConfigMap.columnDefs,
                                        "filter-keys":
                                          _vm.triggerTypeConfigMap.filterKeys,
                                        value: _vm.trackingDetailForm.event,
                                        "event-name": _vm.fieldEventName
                                      },
                                      on: { change: _vm.changeFieldTrigger }
                                    })
                              ]
                            : _vm.trackingDetailForm.triggerWay ===
                                _vm.TRIGGER_WAY_ENUM.SPECIFIC_BUSINESS_RULE &&
                              !!_vm.specificBusinessRules
                            ? [
                                _vm.readOnly ||
                                !_vm.trackingDetailForm.type ||
                                !_vm.specificBusinessRules
                                  ? _c("el-input", {
                                      attrs: {
                                        value:
                                          _vm.specificBusinessRuleEventName,
                                        disabled: ""
                                      }
                                    })
                                  : _c("specific-business-rule-dialog", {
                                      attrs: {
                                        "input-width": "100%",
                                        lob: _vm.currentLob,
                                        "apply-sop-state-trigger": true,
                                        "specific-business-rule-uuid":
                                          _vm.trackingDetailForm.event,
                                        "specific-business-rules":
                                          _vm.specificBusinessRules
                                      },
                                      on: {
                                        change: _vm.specificBusinessRuleChange
                                      }
                                    })
                              ]
                            : _c("el-input", {
                                attrs: { value: "", disabled: "" }
                              })
                        ],
                        2
                      ),
                      _c("el-form-item", [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "100%",
                                  display: "flex",
                                  "align-items": "center"
                                }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    staticStyle: { "flex-grow": "1" },
                                    model: {
                                      value:
                                        _vm.trackingDetailForm
                                          .triggerNodeStateRollback,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.trackingDetailForm,
                                          "triggerNodeStateRollback",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "trackingDetailForm.triggerNodeStateRollback"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.TriggerNodeStatesupConfigured"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm.trackingDetailForm
                                  .triggerNodeStateRollback &&
                                _vm.trackingDetailForm.nodeStatusRollbackList
                                  .length < 5
                                  ? _c("i", {
                                      class:
                                        "el-icon-circle-plus" +
                                        (_vm.readOnly ? " plus-disabled" : ""),
                                      on: { click: _vm.addNodeStatusRollback }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm.trackingDetailForm.triggerNodeStateRollback
                              ? _vm._l(
                                  _vm.trackingDetailForm.nodeStatusRollbackList,
                                  function(item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: _vm.getKey(
                                          _vm.trackingDetailForm
                                            .nodeStatusRollbackList.length,
                                          index
                                        ),
                                        staticStyle: {
                                          width: "100%",
                                          display: "flex",
                                          "align-items": "center"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: {
                                              width: "50px",
                                              "margin-right": "5px",
                                              "flex-grow": "1"
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.onTrackingCodeChange(
                                                  item
                                                )
                                              }
                                            },
                                            model: {
                                              value: item.trackingCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "trackingCode",
                                                  $$v
                                                )
                                              },
                                              expression: "item.trackingCode"
                                            }
                                          },
                                          _vm._l(
                                            _vm.trackingOptionsDict[
                                              item.trackingCode
                                            ],
                                            function(option) {
                                              return _c("el-option", {
                                                key: option.code,
                                                attrs: {
                                                  label: _vm.$selectByLang(
                                                    option.chineseName,
                                                    option.englishName
                                                  ),
                                                  value: option.code
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: {
                                              width: "50px",
                                              "margin-right": "10px",
                                              "flex-grow": "1"
                                            },
                                            model: {
                                              value: item.trackingDetailCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "trackingDetailCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.trackingDetailCode"
                                            }
                                          },
                                          _vm._l(
                                            _vm.trackingDetailOptions.filter(
                                              function(p) {
                                                return (
                                                  p.parentCode ===
                                                    item.trackingCode &&
                                                  p.stateType === 1
                                                )
                                              }
                                            ),
                                            function(option) {
                                              return _c("el-option", {
                                                key: option.code,
                                                attrs: {
                                                  label: _vm.$selectByLang(
                                                    option.chineseName,
                                                    option.englishName
                                                  ),
                                                  value: option.code
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c("i", {
                                          class:
                                            "el-icon-remove" +
                                            (_vm.readOnly
                                              ? " remove-disabled"
                                              : ""),
                                          on: {
                                            click: function($event) {
                                              return _vm.removeNodeStatusRollback(
                                                item
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  }
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]),
                      _vm.isNew || _vm.isEdit
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ApplicationScope")
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value:
                                      _vm.trackingDetailForm.applicationScope,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.trackingDetailForm,
                                        "applicationScope",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "trackingDetailForm.applicationScope"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      staticStyle: { "margin-top": "7px" },
                                      attrs: { label: 0 }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isNew
                                            ? _vm.$t(
                                                "SystemMaintenance.AddOnlyCurrentTemplate"
                                              )
                                            : _vm.$t(
                                                "SystemMaintenance.OnlyModifyCurrentTemplate"
                                              )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-radio",
                                    {
                                      staticStyle: { margin: "5px 0 7px 0" },
                                      attrs: { label: 1 }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isNew
                                            ? _vm.$t(
                                                "SystemMaintenance.AddTemplateSameNode"
                                              )
                                            : _vm.$t(
                                                "SystemMaintenance.ModifyTemplateContinNode"
                                              )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.currentTriggerObj.fieldCode ===
                                "_itrace_code",
                              expression:
                                "currentTriggerObj.fieldCode==='_itrace_code'"
                            }
                          ],
                          attrs: { label: _vm.$t("Sop.ExternalEncoding") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              url: _vm.url.sys.trackingDetailExternal,
                              headers: ["CODE", _vm.$t("SeaExport.Name")],
                              fields: ["code", "serviceName"],
                              "callback-params": { key: "externalCode" },
                              "callback-method-type": "value",
                              "default-value":
                                _vm.trackingDetailForm.externalCode,
                              "static-options": _vm.sopExternalCodeConfigList,
                              "tag-value": "code",
                              "tag-name": "serviceName",
                              "filter-tag-names": ["code", "serviceName"]
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        ],
                        1
                      ),
                      _vm.currentTriggerObj.fieldEname === "生成电子文件"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("FileHistory.jobType") } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "205px" },
                                attrs: {
                                  filterable: "",
                                  headers: [
                                    "CODE",
                                    _vm.$t("SystemMaintenance.ChineseName3")
                                  ],
                                  fields: ["code", "name"],
                                  "callback-params": {
                                    key: "documentTypeUuid"
                                  },
                                  "callback-method-type": "obj",
                                  "default-value":
                                    _vm.trackingDetailForm.documentTypeUuid,
                                  "static-options": _vm.documentTypeList,
                                  "tag-value": "uuid",
                                  "tag-name": "name",
                                  "filter-tag-names": ["code", "name"]
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_WhetherToDisclose")
                          }
                        },
                        [
                          _c("el-checkbox", {
                            model: {
                              value: _vm.trackingDetailForm.published,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.trackingDetailForm,
                                  "published",
                                  $$v
                                )
                              },
                              expression: "trackingDetailForm.published"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Sop.ReportTemplate") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              headers: [_vm.$t("CargoMsg.Cargo_ChineseName")],
                              fields: ["name"],
                              "callback-params": { key: "templateUuid" },
                              "callback-method-type": "value",
                              "default-value":
                                _vm.trackingDetailForm.templateUuid,
                              "static-options": _vm.reportTemplateList,
                              "tag-value": "uuid",
                              "tag-name": "name",
                              "filter-tag-names": ["name"]
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.trackingDetailForm.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.trackingDetailForm, "remark", $$v)
                              },
                              expression: "trackingDetailForm.remark"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("FinanceManage.charge_sp7") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                staticStyle: {
                                  width: "80%",
                                  "padding-right": "10px"
                                },
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.txtCharge,
                                  callback: function($$v) {
                                    _vm.txtCharge = $$v
                                  },
                                  expression: "txtCharge"
                                }
                              }),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.selectHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Select"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-card",
                { ref: "trackNoteByInside", staticStyle: { width: "40%" } },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.readOnly,
                        "label-position": "left",
                        "label-width": "0px"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          attrs: {
                            title: _vm.$t("CargoMsg.Cargo_SendSettings")
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SendSettings")))]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.trackingDetailForm.sendInnerNotify,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm,
                                    "sendInnerNotify",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.sendInnerNotify"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v(_vm._s(_vm.$t("Sop.SendNotifications")))
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("Sop.NotSendNotifications"))
                                )
                              ])
                            ],
                            1
                          ),
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.trackingDetailForm.notifyJobType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm,
                                    "notifyJobType",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.notifyJobType"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_NoticeOfEachBill")
                                  )
                                )
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_NoNoticeOfTickets")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          attrs: {
                            title: _vm.$t(
                              "CargoMsg.Cargo_SetTheNotificationRecipients"
                            )
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "CargoMsg.Cargo_SetTheNotificationRecipients"
                              )
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.trackingDetailForm.innerConfig.post,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "post",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.post"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_DesignatedPost"))
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "15px" },
                          attrs: { label: "" }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value: _vm.trackingDetailForm.innerConfig.sales,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "sales",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.sales"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value: _vm.trackingDetailForm.innerConfig.op,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "op",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.innerConfig.op"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value: _vm.trackingDetailForm.innerConfig.csr,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "csr",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.innerConfig.csr"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.CustomerService"))
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "15px" },
                          attrs: { label: "" }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig.overseaOp,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "overseaOp",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.overseaOp"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.OverseaCustomerService")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value: _vm.trackingDetailForm.innerConfig.dc,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "dc",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.innerConfig.dc"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Documents")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig.planner,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "planner",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.planner"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.AirlinePerson2")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig.cargoSales,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "cargoSales",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.cargoSales"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.SalesOfGoods")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig.siteOp,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "siteOp",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.siteOp"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.FieldOperation")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig
                                    .userDefinedRoleId1,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "userDefinedRoleId1",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.userDefinedRoleId1"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig
                                    .userDefinedRoleId2,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "userDefinedRoleId2",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.userDefinedRoleId2"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig
                                    .userDefinedRoleId3,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "userDefinedRoleId3",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.userDefinedRoleId3"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_userDefinedRole3")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig
                                    .userDefinedRoleId4,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "userDefinedRoleId4",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.userDefinedRoleId4"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_userDefinedRole4")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig
                                    .userDefinedRoleId5,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "userDefinedRoleId5",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.userDefinedRoleId5"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_userDefinedRole5")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig
                                    .userDefinedRoleId6,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "userDefinedRoleId6",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.userDefinedRoleId6"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_userDefinedRole6")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig
                                    .userDefinedRoleId7,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "userDefinedRoleId7",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.userDefinedRoleId7"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_userDefinedRole7")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: !_vm.trackingDetailForm.innerConfig
                                  .post
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig
                                    .userDefinedRoleId8,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "userDefinedRoleId8",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.userDefinedRoleId8"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_userDefinedRole8")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isPlatform,
                                  expression: "!isPlatform"
                                }
                              ],
                              on: {
                                change: function($event) {
                                  _vm.trackingDetailForm.innerConfig.userList = []
                                }
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig.personnel,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "personnel",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.personnel"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_DesignatedPersonnel")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isPlatform,
                              expression: "!isPlatform"
                            }
                          ],
                          attrs: { label: "" }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              fields: ["chineseName"],
                              disabled: !_vm.trackingDetailForm.innerConfig
                                .personnel,
                              "callback-params": { key: "userList" },
                              "callback-method-type": "value",
                              "tag-value": "userId",
                              "tag-name": "chineseName",
                              "filter-tag-names": ["chineseName"],
                              "method-params": {
                                pageSize: 1000000,
                                active: true,
                                hasRole: true
                              },
                              "default-multiple-value":
                                _vm.trackingDetailForm.innerConfig.userList,
                              multiple: "",
                              filterable: "",
                              "options-width": "230px"
                            },
                            on: {
                              parentCallBack: _vm.getInnerConfigValueFromChild
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          staticStyle: { "margin-top": "20px", width: "100%" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_ReminderMethod"))
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.trackingDetailForm.innerConfig.email,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "email",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.email"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Email2")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig.weChat,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "weChat",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.weChat"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Wechat")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig.bellMsg,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "bellMsg",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.bellMsg"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Message.Message")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig
                                    .enterpriseWechat,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "enterpriseWechat",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.enterpriseWechat"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_EnterpriseWechat")
                                )
                              )
                            ]
                          ),
                          _vm.currentTriggerObj.multipleTrigger
                            ? [
                                _c("br"),
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value:
                                        _vm.trackingDetailForm
                                          .valueChangePushMsg,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.trackingDetailForm,
                                          "valueChangePushMsg",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "trackingDetailForm.valueChangePushMsg"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.TriggerTypeChangePushMsg"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          staticStyle: { "margin-top": "20px", width: "100%" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SystemMaintenance.PushExternalInterfaces")
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "215px" },
                              attrs: {
                                "collapse-tags": "",
                                multiple: "",
                                clearable: ""
                              },
                              on: { clear: _vm.handleClear },
                              model: {
                                value:
                                  _vm.trackingDetailForm.externalInterfaceList,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm,
                                    "externalInterfaceList",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.externalInterfaceList"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "SystemMaintenance.XhqBillDataUpdate"
                                  ),
                                  value: "xhqUpdateBillInfo"
                                }
                              }),
                              _c("el-option", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.toExoSystemJYD,
                                    expression: "toExoSystemJYD"
                                  }
                                ],
                                attrs: {
                                  label: _vm.$t(
                                    "SystemMaintenance.msdBillDataUpdate"
                                  ),
                                  value: "msdSendJobInfo"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.currentTriggerObj.multipleTrigger
                            ? [
                                _c("br"),
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value:
                                        _vm.trackingDetailForm
                                          .valueChangePushInterface,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.trackingDetailForm,
                                          "valueChangePushInterface",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "trackingDetailForm.valueChangePushInterface"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.TriggerTypeChangePushInterface"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          staticStyle: { "margin-top": "20px", width: "100%" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SystemMaintenance.TriggerInternalEvent")
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "215px" },
                            attrs: {
                              filterable: "",
                              "static-options": _vm.SHIPPING_MANAGERS,
                              "default-value":
                                _vm.trackingDetailForm.internalEventCode,
                              "tag-name": "chineseName",
                              "tag-value": "code"
                            },
                            on: {
                              parentCallBack: function(p) {
                                return (_vm.trackingDetailForm.internalEventCode =
                                  p.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("tracking-charge-scheme-batch-dialog", {
        attrs: {
          visible: _vm.chargePlanDialog.visible,
          lob: _vm.chargePlanDialog.lob,
          "is-sea": _vm.chargePlanDialog.isSea,
          "selected-list": _vm.chargePlanDialog.selectList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.chargePlanDialog, "visible", $event)
          },
          selectedSchemeHandler: function(schemeDetails) {
            _vm.selectedSchemeHandler(schemeDetails)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }